import { useState, useEffect, useContext, useRef } from "react";
import { FaSearch } from "react-icons/fa";
import { useDebounce } from "../utils/usedebounce";
import axiosInstance from "../utils/AxiosInstance";
import AddReportModal from "../Reports/AddReportModal";
import { AppContext } from "../context/AppContext";
import { msalInstance } from "../msal/msal";
import * as powerbi from "powerbi-client";
import { models } from "powerbi-client";
import { useMsal } from "@azure/msal-react";
import ConfirmationModal from "../widgets/ConfirmationModal";
import ConfirmationModalRls from "../widgets/ConfirmationModalRls";
import zIndex from "@mui/material/styles/zIndex";
import { MdRefresh, MdClose } from "react-icons/md";
import ReportCard from "./ReportCard";
import image from "../assets/images/Abrams.png";
import { MdFullscreen, MdFullscreenExit, MdPictureAsPdf } from "react-icons/md";

import axios from "axios";
import { getActivityActor } from "../utils/activityActor";

const Reports = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [status, setStatus] = useState();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const reportRef = useRef(null);

  const {
    setLoader,
    setToast,
    confirmationModal,
    confirmationModalRls,
    setConfirmationModal,
    setConfirmationModalRls,
    roles,
    setSelectedReportId,
    setViewerReports,
    loader,
    modal,
    setModal,
    setRoles,
    bookmarks,
    groupRollups,
    item,
    setItem,
    setGroupRollups,
    setBookMarks,
    isEditMode,
    isPowerBi,
    embedToken,
    setEmbedToken,
    setPowerBi,
    setEditMode,
    selectedReport,
    setSelectedReport,
    activeTab,
    setActiveTab,
    reportUrls,
    setReportUrls,
    allApplication,
    setAllApplication,
  } = useContext(AppContext);
  const [token, setToken] = useState(null);
  const iframeRef = useRef(null);
  const { instance } = useMsal();

  const account = instance.getActiveAccount();
  const normalizedAccountEmail = account?.username?.trim().toLowerCase();
  const actor = getActivityActor(account);
  const [workspaces, setWorkSpaces] = useState([]);
  const [workspaceId, setWorkspaceId] = useState([]);
  const [workSpaceReports, setWorkSpaceReports] = useState([]);
  const [pipelines, setPipelines] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [loading, setLoading] = useState(false);
  const [maintenanceMode, setMaintenanceMode] = useState(false);

  // 🔹 NEW: Pages sidebar state
  const [pages, setPages] = useState([]);
  const [activePage, setActivePage] = useState(null);

  var report;

  // Inside your component

const embedReport = (reportId, embedToken, filter = null) => {
    const embedConfig = {
      type: "report",
      id: reportId,
      embedUrl: `https://app.powerbi.com/reportEmbed?reportId=${reportId}`,
      accessToken: embedToken,
      tokenType: models.TokenType.Embed,
      settings: {
        panes: {
          filters: { visible: false },
          pageNavigation: { visible: false }, // hide default page nav
        },
        customCommands: [
          {
            name: "refreshReport",
            displayName: "Refresh Report",
            icon: "Refresh",
            title: "Click to refresh",
          },
        ],
      },
    };

    const handleCustomCommand = (event) => {
      if (!event.detail || !event.detail.command) return;
      if (event.detail.command === "refreshReport") {
        const report = powerbi.get(document.getElementById("report-container"));
        if (report) {
          report.refresh();
        }
      }
    };

    window.addEventListener("message", handleCustomCommand);
    const reportContainer = document.getElementById("powerbi-container");
    const powerbiService = new powerbi.service.Service(
      powerbi.factories.hpmFactory,
      powerbi.factories.wpmpFactory,
      powerbi.factories.routerFactory
    );
    powerbiService.reset(reportContainer);


    const newReport = powerbiService.embed(reportContainer, embedConfig);
    report = newReport;

    //   // 🔹 Fetch and set pages
    // const reportPages = await newReport.getPages();
    // const visiblePages = reportPages.filter(
    //   (p) => p.visibility !== models.SectionVisibility.Hidden
    // );
    // setPages(visiblePages);
    // setActivePage(visiblePages.find((p) => p.isActive)?.name || null);

    //   if (
    //     filter &&
    //     Array.isArray(filter.values) &&
    //     !filter.values.includes("*") &&
    //     filter.values.length > 0
    //   ) {
    //     applyPowerBIFilter(filter);
    //   }
    // });

    newReport.on("loaded", async function () {
      console.log("Power BI Report Loaded");

      const reportPages = await newReport.getPages();


      // 🔹 Only include pages with visibility 0
      const visiblePages = reportPages.filter(
        (p) => p.visibility === 0
      );


      console.log("Visible Pages:", visiblePages);

      setPages(visiblePages);
      setActivePage(visiblePages.find((p) => p.isActive)?.name || null);

      if (
        filter &&
        Array.isArray(filter.values) &&
        !filter.values.includes("*") &&
        filter.values.length > 0
      ) {
        applyPowerBIFilter(filter);
      }
    });

    newReport.on("error", function (event) {
      console.error("Power BI Report Error:", event.detail);
    });
  };

  function applyPowerBIFilter(filter) {
    if (!report) {
      console.error("Power BI report is not initialized yet.");
      return;
    }
    report
      .getFilters()
      .then((existingFilters) => {
        report.updateFilters(models.FiltersOperations.Replace, [filter]);
      })
      .catch((error) => console.error("Error applying filter:", error));
  }

  // 🔹 NEW: Handle page switch
  const handlePageChange = async (page) => {
    try {
      await page.setActive();
      setActivePage(page.name);
    } catch (err) {
      console.error("Error switching page:", err);
    }
  };

  useEffect(() => {
    if (item) {
      handleReportClick(item);
    }
  }, [isPowerBi, item]);

  const handleReload = () => {
    handleReportClick(item);
  };

  // const handleReportClick = async (report) => {
  //     setViewerReports([]);   // clear report viewer data

  //   const adminEditor =
  //     roles?.role_name?.includes("Admin") ||
  //     roles?.role_name?.includes("Editor");

  //   if (!adminEditor && (status == 0 || status?.length == 0)) {
  //     setLoader(false);
  //     return;
  //   }
  //   setItem(report);

  //   const responseResult = await fetchGroupRollups(
  //     account.username,
  //     report.report.id
  //   );

  //   let filterValue;
  //   if (responseResult?.VALUE && typeof responseResult.VALUE === "string") {
  //     filterValue = responseResult?.VALUE?.split(",").map((item) =>
  //       item.trim()
  //     );
  //   }

  //   if (!adminEditor && !filterValue) {
  //     setLoader(false);
  //     return;
  //   }

  //   setPowerBi(true);

  //   try {
  //     const filter = {
  //       $schema: "http://powerbi.com/product/schema#basic",
  //       target: {
  //         table: responseResult?.TABLE,
  //         column: responseResult?.COLUMN,
  //       },
  //       operator: "In",
  //       values: filterValue,
  //     };

  //     const response = await axiosInstance.post("/get_embed_token", {
  //       WORKSPACE_ID: report.workspace.id,
  //       REPORT_ID: report.report.id,
  //     });
  //     setEmbedToken(response.data.embed_token);
  //     embedReport(report.report.id, response.data.embed_token, filter);
  //     setLoader(false);
  //   } catch (err) {
  //     console.log("An error while generating embeded token", err);
  //     setLoader(false);
  //   }
  // };

  const clearPowerBiReport = () => {
    try {
      const reportContainer = document.getElementById("powerbi-container");
      if (reportContainer) {
        const powerbiService = new powerbi.service.Service(
          powerbi.factories.hpmFactory,
          powerbi.factories.wpmpFactory,
          powerbi.factories.routerFactory
        );
        powerbiService.reset(reportContainer);
      }
    } catch (e) {
      // ignore if container or service not available
    }
  };

  const handleReportClick = async (report) => {
    console.log(report.report.id, "report1234567");
    setMaintenanceMode(false);
    clearPowerBiReport();
    // 🔹 Clear old report data instantly
    setPages([]); // clear pages immediately
    setActivePage(null); // reset selected page
    setLoader(true); // show loader until embed completes

    setItem(report);

    if (report?.type === "Web Application") {
      //  alert("special")
      console.log("report.report.id:", report.report.id);
      console.log("reportUrls:", reportUrls);

      const app = allApplication.find(
        (r) => String(r.ID) === String(report.report.id)
      );

      console.log(allApplication, app, "url123");
      if (app?.URL) {
        window.open(app.URL, "_parent"); // open in new tab
      } else {
        console.warn("URL not found for report ID:", report.report.id);
      }

      setLoader(false);
      return; // stop further execution
    }

    const responseResult = await fetchGroupRollups(
      normalizedAccountEmail,
      report.report.id
    );

    if (responseResult?.__maintenance) {
      setMaintenanceMode(true);
      setPowerBi(true);
      setLoader(false);
      return;
    }

    let filterValue;
    if (responseResult?.VALUE && typeof responseResult.VALUE === "string") {
      filterValue = responseResult?.VALUE?.split(",").map((item) =>
        item.trim()
      );
    }

    setPowerBi(true);

    try {
      const filter = {
        $schema: "http://powerbi.com/product/schema#basic", 
        target: {
          table: responseResult?.TABLE,
          column: responseResult?.COLUMN,
        },
        operator: "In",
        values: filterValue,
      };

      // 🔹 Fetch embed token
      const response = await axiosInstance.post("/get_embed_token", {
        WORKSPACE_ID: report.workspace.id,
        REPORT_ID: report.report.id,
      });

      setEmbedToken(response.data.embed_token);

      embedReport(report.report.id, response.data.embed_token, filter);

      setPages(newPages);
      if (newPages.length > 0) {
        setActivePage(newPages[0].name);
      }

      setLoader(false);
    } catch (err) {
      console.error("An error while generating embed token", err);
      if (err.response?.status === 500) {
        setMaintenanceMode(true);
        setPowerBi(true);
      }
      setLoader(false);
    }
  };
  useEffect(() => {
    console.log(item?.workspace?.id, "item+++++++++++++");
  }, [item]);
  const fetchGroupRollups = async (email, report) => {
    const adminEditor =
      roles?.role_name?.includes("Admin") ||
      roles?.role_name?.includes("Editor");

    console.log("adminEdit", adminEditor);
    if (adminEditor) {
      return [];
    }

    const body = { email: email, report_id: report };
    try {
      const response = await axiosInstance.post("/GL-By-email", body);
      let groupRollups = response?.data?.data[0] || [];

      return groupRollups;
    } catch (err) {
      console.error("API Error:", err);
      if (err.response?.status === 500) {
        return { __maintenance: true };
      }
      return [];
    } finally {
      setLoader(false);
    }
  };

  const handleCloseReport = () => {
    setMaintenanceMode(false);
    setPowerBi(false);
    setItem(null);
    setSelectedReportId(null);
    setPages([]);
    setActivePage(null);
  };

  const fetchWorkspaces = async (selectedPipeline) => {
    try {
      setLoader(true);
      const response = await axiosInstance.post("/Get_all_workspaces", {
        pipelineId: selectedPipeline,
      });
      if (response.data) {
        console.log("workspaces data", response.data);
        const cleanedWorkspaces = response.data?.value
          ?.filter((item) => item.workspaceId && item.workspaceName)
          .map((item) => ({
            value: item.workspaceId,
            label: item.workspaceName,
          }));

        setWorkSpaces(cleanedWorkspaces);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      setLoader(false);
    }
  };

  const fetchWorkspacesReports = async (workspaceId) => {
    setLoader(true);

    console.log("workspaceId", workspaceId);
    try {
      const response = await axiosInstance.post("/Get_all_reports", {
        WORKSPACE_ID: workspaceId,
      });
      if (response.data) {
        setWorkSpaceReports(
          response.data?.value?.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        );
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      setLoader(false);
    }
  };

  const fetchPipelines = async () => {
    try {
      setLoader(true);
      const response = await axiosInstance.get("/getPipelines");
      if (response.data) {
        console.log("pipelines data", response.data);
        setPipelines(
          response.data?.value?.map((item) => ({
            value: item.id,
            label: item.displayName,
          }))
        );
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching pipelines:", error);
      setLoader(false);
    }
  };

  const debouncedSearchTerm = useDebounce(searchTerm, 700);
  useEffect(() => {
    // alert("DEBOUNCE")
    if (token) fetchData(debouncedSearchTerm);
  }, [debouncedSearchTerm, token]);

  // Fetch data function
  const fetchData = async (searchTerm) => {
    try {
      setLoader(true);

      const cleanSearchTerm = searchTerm?.trim();
      const response = await axiosInstance.get(
        `/bookmarks${cleanSearchTerm ? "?search=" + cleanSearchTerm : ""}`
      );
      console.log("fetchdatacalled2");
      if (response.status === 200) {
        setBookMarks(response.data);
      }

      setTimeout(() => {
        setLoader(false);
      }, 1000);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    }
  };

  const deleteReportCard = async (id) => {
    setLoader(true);
    try {
      const response = await axiosInstance.delete(`/delete-bookmarks/${id}`, {
        data: { ...actor },
      });

      if (response.status === 200) {
        setLoader(false);
        console.log("delte data", response.data);
        setBookMarks((prevBookmarks) =>
          prevBookmarks.filter((item) => item._id !== id)
        );
        setToast({
          show: true,
          type: "success",
          message: `Report deleted successfully`,
        });
        setConfirmationModal({ id: "", show: false });
        setConfirmationModalRls({
          show: false,
          id: "",
          reportId: "",
        });
      }
    } catch (error) {
      setLoader(false);

      console.error("Error deleting report card:", error);
    }
  };

  const deleteRlsLinked = async (reportId, id) => {
    console.log("453", id);
    setLoader(true);
    try {
      const response = await axiosInstance.delete("/deleteRlsByReportId", {
        data: { reportId: reportId, id: id, ...actor },
      });

      if (response.status === 200) {
        // setLoader(false);
        console.log("delte data", response.data);
        setConfirmationModal({ id: "", show: false });
        setConfirmationModalRls({
          show: false,
          id: "",
          reportId: "",
        });
      }
    } catch (error) {
      setLoader(false);

      console.error("Error deleting report card:", error);
    }
  };

  const deleteReportCardRls = async (id, reportId) => {
    console.log("4534", reportId, id);
    await deleteRlsLinked(reportId, id);
    await deleteReportCard(id);
  };

  // Updated function
  const handleFullScreen = () => {
    const container = iframeRef.current;
    if (!container) return;

    if (!document.fullscreenElement) {
      // ✅ Enter fullscreen
      if (container.requestFullscreen) container.requestFullscreen();
      else if (container.webkitRequestFullscreen)
        container.webkitRequestFullscreen();
      else if (container.msRequestFullscreen) container.msRequestFullscreen();

      setIsFullScreen(true);
    } else {
      // ✅ Exit fullscreen
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      else if (document.msExitFullscreen) document.msExitFullscreen();

      setIsFullScreen(false);
    }
  };

  useEffect(() => {
    const handleFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullScreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
  }, []);

  const handleDownloadPDF = async () => {
    try {
      setLoading(true);

      const workspaceId = item?.workspace?.id;
      const reportId = item?.report?.id;
      console.log(workspaceId, reportId, "workspaceIdworkspaceIdworkspaceId");
      // Call your backend API
      const response = await axios.post(
        "http://localhost:8080/api/export_powerbi_report",
        { workspaceId, reportId },
        { responseType: "blob" }
      );

      // Create a blob and trigger download
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "PowerBI_Report.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      console.log("PDF downloaded successfully!");
    } catch (err) {
      console.error("Download failed:", err);
      alert("Failed to export the report. Please try again.");
    } finally {
      setLoading(false);
    }
    // try {
    //   const workspaceId = "974bd871-3f8b-4df6-ab0a-6ac4eb182d0b";
    //   const reportId = "f9366af4-5455-446b-805b-2dffc261b416";

    //   const response = await axios.post(
    //     "http://localhost:8080/api/export_powerbi_report",
    //     { workspaceId, reportId },
    //     { responseType: "blob" } // important for PDF
    //   );

    //   const blob = new Blob([response.data], { type: "application/pdf" });
    //   const url = window.URL.createObjectURL(blob);
    //   const a = document.createElement("a");
    //   a.href = url;
    //   a.download = "PowerBI_Report.pdf";
    //   document.body.appendChild(a);
    //   a.click();
    //   a.remove();
    //   window.URL.revokeObjectURL(url);
    // } catch (err) {
    //   alert("Failed to export the report. Please try again.");
    // }
  };

  return (
    <div className="">
      {modal && (
        <AddReportModal
          isOpen={modal}
          onClose={() => setModal(false)}
          fetchData={fetchData}
          isEditMode={isEditMode}
          editData={selectedReport}
          setEditData={setSelectedReport}
          setEditMode={setEditMode}
          workspaces={workspaces}
          fetchWorkspaces={fetchWorkspaces}
          workSpaceReports={workSpaceReports}
          fetchWorkspacesReports={fetchWorkspacesReports}
          pipelines={pipelines}
          fetchPipelines={fetchPipelines}
        />
      )}

      {confirmationModalRls?.show ? (
        <ConfirmationModalRls
          onDelete={() => deleteReportCard(confirmationModalRls.id)}
          onDeleteRls={() =>
            deleteReportCardRls(
              confirmationModalRls.id,
              confirmationModalRls.reportId
            )
          }
          isOpen={confirmationModal}
          onClose={() =>
            setConfirmationModalRls({
              show: false,
              id: "",
              reportId: "",
            })
          }
          title={
            "There is RLS or Reports/Applications on this report. Please select one option to proceed."
          }
        />
      ) : (
        <>
          {confirmationModal?.show && (
            <ConfirmationModal
              onDelete={() => deleteReportCard(confirmationModal.id)}
              isOpen={confirmationModal}
              onClose={() => setConfirmationModal({ id: "", show: false })}
              title={"Are you sure, you want to delete the Card"}
            />
          )}
        </>
      )}

      {isPowerBi ? (
        // ⬇️ Put ref on the top-level wrapper so sidebar + report go fullscreen together
        <div
          ref={iframeRef}
          className={`${
            isFullScreen
              ? "fixed inset-0 z-[9999]" // full viewport in fullscreen
              : "w-full h-[90vh] rounded-lg shadow-md"
          } bg-gray-100 relative flex transition-all duration-300`}
          id="powerbi-fullscreen-wrapper"
        >
          {/* 🔹 Sidebar for pages */}
          {/* 🔹 Sidebar and Toggle */}
          {/* 🔹 Sidebar and Toggle */}
          {pages.length > 1 && (
            <>
              {/* Sidebar */}
              <div
                className={`h-full bg-white border-r shadow-md overflow-y-auto transition-all duration-300 ${
                  sidebarOpen ? "w-64" : "w-0"
                }`}
              >
                {sidebarOpen && (
                  <div className="h-full flex flex-col">
                    <div className="p-4 flex justify-between items-center border-b">
                      <h3 className="text-lg font-semibold">Pages</h3>
                      <button
                        title="Hide the pages pane"
                        onClick={() => setSidebarOpen(false)}
                        className="p-2 text-gray-600 hover:text-black"
                      >
                        &#x3C;&#x3C;
                      </button>
                    </div>
                    <ul className="p-4 space-y-2 flex-1 overflow-y-auto">
                      {pages.map((p) => (
                        <li
                          key={p.name}
                          className={`cursor-pointer px-3 py-2 rounded-md ${
                            activePage === p.name
                              ? "bg-red-200 text-[#E31c23] font-bold"
                              : "hover:bg-rose-100"
                          }`}
                          onClick={() => handlePageChange(p)}
                        >
                          {p.displayName}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {/* ✅ Always visible toggle button */}
              {!sidebarOpen && (
                <button
                  title="Show the pages pane"
                  onClick={() => setSidebarOpen(true)}
                  className="absolute top-4 left-4 z-[10000] p-2 bg-white/90 backdrop-blur-sm border rounded-md shadow-md hover:bg-white"
                >
                  &#x3E;&#x3E;
                </button>
              )}
            </>
          )}

          {/* 🔹 Report + Toolbar Area */}

          <div className="flex-1 flex flex-col bg-white relative">
            {/* Toolbar */}
            <div className="flex justify-between items-center bg-white shadow-md border-b p-2 z-50">
              {/* Left side - Download button */}
              <div className="ml-[60px]">
                {/* <button
                  onClick={handleDownloadPDF}
                  disabled={loading}
                  className={`p-2 px-4 rounded text-white transition ${
                    loading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-red-500 hover:bg-red-600"
                  }`}
                  title="Download Power BI report as PDF"
                >
                  {loading ? (
                    <div className="flex items-center gap-2">
                      <svg
                        className="animate-spin h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                        ></path>
                      </svg>
                      <span>Downloading...</span>
                    </div>
                  ) : (
                    "Download PDF"
                  )}
                </button> */}
              </div>

              {/* Right side - other buttons */}
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => handleReload(item)}
                  className="p-2 text-red-500 hover:text-red-700 transition-colors duration-200"
                  title="Refresh Report"
                >
                  <MdRefresh size={22} />
                </button>

                <button
                  onClick={handleFullScreen}
                  className="p-2 text-red-500 hover:text-red-700 transition-colors duration-200"
                  title={
                    isFullScreen ? "Exit Full Screen" : "Enter Full Screen"
                  }
                >
                  {isFullScreen ? (
                    <MdFullscreenExit size={24} />
                  ) : (
                    <MdFullscreen size={24} />
                  )}
                </button>

<button
  onClick={() => {
    if (isFullScreen) handleFullScreen(); // exit fullscreen first
    handleCloseReport(); // then close the report
  }}
  className="p-2 text-red-500 hover:text-red-900 transition-colors duration-200"
  title="Close Report"
>
  <MdClose size={22} />
</button>

              </div>
            </div>

            {/* Power BI Report or Maintenance screen */}
            {maintenanceMode ? (
              <div className="flex-1 flex items-center justify-center bg-gray-50 p-8">
                <div className="text-center max-w-md bg-white rounded-xl shadow-lg border border-gray-200 p-8">
                  <div className="mx-auto w-16 h-16 mb-4 rounded-full bg-amber-100 flex items-center justify-center">
                    <svg
                      className="w-8 h-8 text-amber-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                      />
                    </svg>
                  </div>
                  <h2 className="text-xl font-semibold text-gray-800 mb-2">
                    System Under Maintenance
                  </h2>
                  <p className="text-gray-600 mb-6">
                    This report could not be loaded. Please try again after some time or contact your administrator.
                  </p>
                  <button
                    onClick={handleCloseReport}
                    className="px-5 py-2.5 bg-[#E31c23] hover:bg-[#c4181e] text-white font-medium rounded-lg transition-colors"
                  >
                    Back to Reports
                  </button>
                </div>
              </div>
            ) : (
              <div
                id="powerbi-container"
                className="flex-1 w-full overflow-hidden"
              ></div>
            )}
          </div>
        </div>
      ) : (
        <div className="flex h-[70vh] justify-center items-center">
          <img src={image} className="max-h-[25vh] max-w-full object-contain" />
        </div>
      )}
    </div>
  );
};

export default Reports;
